const Logo = (props) => (
  <img
    alt="Logo"
    src="https://github.com/GEPTON-INFOTECH/GEPTON-INFOTECH/raw/main/branding/logo-139x52(blue-background).png"
    {...props}
  />
);

export default Logo;
